<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <h4 slot="header" class="card-title text-left m-0">
          Exportar TXT para Folha
        </h4>

        <div
          class="tab-content"
          id="pills-tabContent"
          style="min-height: 100px;"
        >
          <div
            v-show="itemMenu == 1"
            class="tab-pane fade"
            :class="itemMenu == 1 ? 'show active' : ''"
          >
            <div class="row center-content-center mt-4">
              <div class="col-md-12 text-left mt-4 row">
                <label>
                  Layout TXT
                </label>
                <el-select
                  name="rubrica"
                  required
                  class="select-success col-sm-12 pagination-select"
                  v-model="payload.rubrica"
                  :class="error.id_posto === true ? 'has-danger' : ''"
                  placeholder="Selecione o Layout"
                >
                  <el-option
                    v-for="item in rubricas"
                    :key="item.id"
                    class="select-success"
                    :label="item.rubrica"
                    :value="item.rubrica"
                    >{{ item.rubrica }}</el-option
                  >
                </el-select>
              </div>

              <div class="col-md-12 text-left mt-4 row">
                <label>
                  Posto de Trabalho
                </label>
                <el-select
                  name="posto"
                  required
                  class="select-success col-sm-12 pagination-select"
                  v-model="payload.id_posto"
                  :class="error.id_posto === true ? 'has-danger' : ''"
                  placeholder="Selecione o Posto de Trabalho"
                >
                  <el-option
                    v-for="item in postos"
                    :key="item.id"
                    class="select-success"
                    :label="item.local"
                    :value="item.id"
                    >{{ item.local }}</el-option
                  >
                </el-select>
              </div>

              <div class="col-md-12 text-left mt-4 row">
                <label>
                  Departamento
                </label>
                <el-select
                  name="departamento"
                  required
                  class="select-success col-sm-12 pagination-select"
                  v-model="payload.id_departamento"
                  :class="error.id_departamento === true ? 'has-danger' : ''"
                  placeholder="Selecione o Departamento"
                >
                  <el-option
                    v-for="item in departamentos"
                    :key="item.id"
                    class="select-success"
                    :label="item.descricao"
                    :value="item.id"
                    >{{ item.descricao }}</el-option
                  >
                </el-select>
              </div>

              <div class="col-sm-12 text-left mt-1 form-group has-label row">
                <label>
                  Funcionário
                </label>
                <autocomplete
                  class="col-12"
                  :search="carregarFuncionario"
                  placeholder="Selecionar Funcionário"
                  aria-label="Selecionar Funcionário"
                  :get-result-value="procurarFuncionario"
                  @submit="selecionarFuncionario"
                >
                </autocomplete>
              </div>

              <div class="col-md-12 text-left mt-4 row">
                <div class="col-md-6 text-left">
                  <base-input
                    label="Data Inicial"
                    type="date"
                    placeholder="dia/mês/ano"
                    v-model="payload.data_inicial"
                  >
                  </base-input>
                </div>
                <div class="col-md-6 text-left">
                  <base-input
                    label="Data Final"
                    type="date"
                    placeholder="dia/mês/ano"
                    v-model="payload.data_final"
                  >
                  </base-input>
                </div>
              </div>

              <div class="col-sm-12 justify-content-end mt-4 row">
                <div class="text-center col-sm-3 col-8 animation-on-hover">
                  <base-button
                    block
                    type="success"
                    @click="findDataDailog()"
                    :disabled="validateForm()"
                    >Exportar Arquivo</base-button
                  >
                </div>
                <div class="text-center col-sm-3 col-8 animation-on-hover">
                  <base-button block type="warning" @click="limparFiltro"
                    >Limpar Filtros</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="openDialog">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Configuração de Código Contábil
        </h4>
      </template>
      <div class="d-flex row">
        <div class="col-md-12 pr-md-0 text-left">
          <div class="col-md-12 text-left mt-0 row">
            <div class="col-md-6 text-left mt-0 row">
              <label>
                Faltas em horas
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Faltas em horas"
                v-model="config.faltasHoras"
              />
            </div>
            <div class="col-md-6 text-left mt-0 row">
              <label>
                Faltas em dias
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Faltas em horas"
                v-model="config.faltasDias"
              />
            </div>
          </div>
          <div class="col-md-12 text-left mt-0 row">
            <div class="col-md-6 text-left mt-0 row">
              <label>
                Atraso em horas
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Faltas em horas"
                v-model="config.atrasoHoras"
              />
            </div>
            <div class="col-md-6 text-justify mt-0 row">
              <label>
                Adicional noturno
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Faltas em horas"
                v-model="config.adNoturnoHoras"
              />
            </div>
          </div>
          <div class="col-md-12 text-left mt-0 row">
            <div class="col-md-6 text-left mt-0 row">
              <label>
                Hora Extra 50%
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Faltas em horas"
                v-model="config.horaExtra50"
              />
            </div>
            <div class="col-md-6 text-left mt-0 row">
              <label>
                Hora Extra 100%
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Faltas em horas"
                v-model="config.horaExtra100"
              />
            </div>
          </div>
          <div class="col-md-12 text-left mt-0 row">
            <div class="col-md-12 text-left mt-0 row">
              <label>
                Código da Empresa
              </label>
              <input
                name="ftHoras"
                class="col-sm-6"
                disabled
                placeholder="Opcional"
                v-model="config.codEmpresa"
              />
            </div>
          </div>
          <div class="col-sm-16 text-left mt-3 row">
            <p class="text-danger font-weight-bold">
              ⚠ Atenção:
            </p>
            <p class="text-danger font-weight">
              Nos layouts da Alterdata e Domínio, é necessário que os
              funcionários tenham matrícula cadastrada para que o arquivo seja
              gerado corretamente. Verifique as informações antes de continuar.
            </p>
            <p class="text-danger font-weight">
              Antes de continuar, é importante verificar suas configurações.
            </p>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="w-80 d-flex justify-content-end">
          <base-button type="success" @click="exportarArquivoTxt()"
            >Continuar</base-button
          >
        </div>
      </template>
    </modal>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import swal from "sweetalert2";
import { BaseInput } from "@/components/index";
import Fuse from "fuse.js";
import Modal from "@/components/Modal.vue";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      openDialog: false,
      isLoading: false,
      itemMenu: 1,
      file: null,
      fuseSearch: null,
      dadosUsuario: "",
      sinc_or_create: "Sincronizando",
      rubricas: [],
      funcionarios: [],
      postos: [],
      departamentos: [],
      block: {
        departamento: true,
        posto: true,
        funcionario: true,
        data_final: "",
        data_inicial: "",
      },
      payload: {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        rubrica: "",
        id_posto: "",
        id_funcionario: "",
        idUsuario: "",
        id_empregador: "",
      },
      config: {
        rubrica: "",
        faltasHoras: "",
        faltasDias: "",
        atrasoHoras: "",
        adNoturnoHoras: "",
        horaExtra50: "",
        horaExtra100: "",
        codEmpresa: "",
      },
      error: {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
        idUsuario: "",
      },
    };
  },
  components: {
    Loading,
    BaseInput,
    Modal,
  },

  mounted() {
    this.listarDepartamentos();
    this.listarPostos();
    this.listarFuncionarios();
    this.listarRubricas();
  },

  methods: {
    limparFiltro() {
      this.payload = {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
      };
    },

    validateForm() {
      if (
        this.payload.rubrica &&
        this.payload.data_final &&
        this.payload.data_inicial
      ) {
        return false;
      }
      return true;
    },

    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    selecionarFuncionario(result) {
      if (result) {
        this.payload.id_funcionario = result.id;
        return result.nome;
      } else return "";
    },
    procurarFuncionario(result) {
      if (result) return result.nome;
      else return "";
    },
    carregarFuncionario(input) {
      if (input.length > 1) return this.fuseSearch.search(input);
      else {
        this.payload.id_funcionario = "";
        return this.funcionarios;
      }
    },

    listarDepartamentos() {
      let th = this;
      this.block.departamento = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.block.departamento = false;
          th.departamentos = response.data.data.dados;
        })
        .catch((err) => {
          th.block.departamento = false;
          console.log(err);
        });
    },

    listarRubricas() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/exportacao/listarRubricas", bodyFormData)
        .then((response) => {
          th.rubricas = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    listarPostos() {
      this.block.posto = true;
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.block.posto = false;
          th.postos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.block.posto = false;
        });
    },

    listarFuncionarios() {
      let th = this;
      this.block.funcionario = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.block.funcionario = false;
          th.funcionarios = response.data.data.dados;

          th.fuseSearch = new Fuse(th.funcionarios, {
            keys: ["nome", "cpf"],
            threshold: 0.3,
          });
        })
        .catch(() => {
          th.block.funcionario = false;
        });
    },

    findDataDailog() {
      for (let rubrica of this.rubricas) {
        if (rubrica.rubrica == this.payload.rubrica) {
          this.config.rubrica = rubrica.rubrica;
          this.config.adNoturnoHoras = rubrica.adNoturnoHoras;
          this.config.atrasoHoras = rubrica.atrasoHoras;
          this.config.faltasDias = rubrica.faltasDias;
          this.config.faltasHoras = rubrica.faltasHoras;
          this.config.horaExtra100 = rubrica.horaExtra100;
          this.config.horaExtra50 = rubrica.horaExtra50;
          this.config.codEmpresa = rubrica.codEmpresa;
        }
      }

      this.openDialog = true;
    },

    exportarArquivoTxt() {
      this.openDialog = false;
      this.isLoading = true;
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        data_final: this.payload.data_final,
        rubrica: this.payload.rubrica,
        data_inicial: this.payload.data_inicial,
        id_departamento: this.payload.id_departamento,
        id_posto: this.payload.id_posto,
        id_empregador: this.$cookies.get("idEmpregador"),
        id_funcionario: this.payload.id_funcionario,
      };

      this.axios
        .post("/api/exportacao/arquivoTxt", bodyFormData, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "text/plain" });
          saveAs(blob, "arquivo_exportado.txt");
        })
        .catch(() => {
          th.showSwal(
            "auto-close",
            "Erro",
            "Ocorreu algum erro ao exportar arquivo!",
            "error",
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
  },
};
</script>
